import { render, staticRenderFns } from "./NursesSelectbox.vue?vue&type=template&id=2db4b9e4"
import script from "./NursesSelectbox.vue?vue&type=script&lang=js"
export * from "./NursesSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports